import {
  DIGITAL_TYPE_SIGN_SYSTEM,
  DIGITAL_TYPE_SIGN_USER,
  SIGN_PROVIDER,
  SIGN_VISIBLE,
} from '../../../../../constants'
import { DEFAULT_SIGN_COORDS } from '../canvasDocConstants'

export const buildSignPayload = (fileIds, signature, options = {}) => {
  const { addFooter = false } = options
  const basePayload = {
    reason: 'Signed',
    location: 'VietNam',
    contactInfo: '',
    provider: SIGN_PROVIDER.VNPT,
    isVisible: SIGN_VISIBLE.HIDE,
    page: DEFAULT_SIGN_COORDS.page,
    visibleType: '1',
    llx: DEFAULT_SIGN_COORDS.llx,
    lly: DEFAULT_SIGN_COORDS.lly,
    urx: DEFAULT_SIGN_COORDS.urx,
    ury: DEFAULT_SIGN_COORDS.ury,
    addFooter,
    listSignFile: fileIds.map(fileId => ({ fileId })),
  }

  if (!signature) {
    return {
      ...basePayload,
      type: DIGITAL_TYPE_SIGN_SYSTEM,
      image: '',
    }
  }

  return {
    ...basePayload,
    type:
      signature.type === DIGITAL_TYPE_SIGN_SYSTEM
        ? DIGITAL_TYPE_SIGN_SYSTEM
        : DIGITAL_TYPE_SIGN_USER,
    image: signature.signId,
  }
}
